import { RouteObject } from 'react-router-dom';
import { Suspense, lazy } from 'react';
import { LoadingSpinner } from '@/components/ui/loading-spinner';

const Auth = lazy(() => import('@/pages/auth/Auth'));
const AuthCallback = lazy(() => import('@/pages/auth/AuthCallback'));
const Logout = lazy(() => import('@/pages/auth/Logout'));

export const authRoutes: RouteObject[] = [
  {
    path: 'auth',
    children: [
      {
        index: true,
        element: (
          <Suspense fallback={<LoadingSpinner size="md" />}>
            <Auth />
          </Suspense>
        ),
      },
      {
        path: 'callback',
        element: (
          <Suspense fallback={<LoadingSpinner size="md" />}>
            <AuthCallback />
          </Suspense>
        ),
      },
      {
        path: 'logout',
        element: (
          <Suspense fallback={<LoadingSpinner size="md" />}>
            <Logout />
          </Suspense>
        ),
      },
    ],
  },
];
